import { ModelCollection } from '@/modules/core/app/models/ModelCollection';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { BaseWorkflowRule } from '@/modules/workflow/models/BaseWorkflowRule';
import { WorkflowRuleSelect } from '@/modules/workflow/models/WorkflowRuleSelect';

export abstract class BaseWorkflowRuleCollection<
  T extends BaseWorkflowRule
> extends ModelCollection<T> {
  abstract sync(newRules: unknown[]): void;

  abstract get ruleType(): string;

  abstract get ruleSelection(): BaseModel[];

  syncRules(newRules: T[]): void {
    const currentRuleIds: Array<string | undefined> =
      this.items?.map((rule: T): string | undefined => rule.ruleId) ?? [];

    const newRuleIds: Array<string | undefined> = newRules.map(
      (rule: T): string | undefined => rule.ruleId
    );

    const currentRules: T[] =
      this.items?.filter((rule: T): boolean => newRuleIds.includes(rule.ruleId)) ?? [];

    newRules.forEach((rule: T): void => {
      if (currentRuleIds.includes(rule.ruleId)) {
        return;
      }

      currentRules.push(rule);
    });

    this.items = currentRules;
  }

  clearRules(ruleSelects: WorkflowRuleSelect[]): void {
    if (
      ruleSelects.some(
        (ruleSelect: WorkflowRuleSelect): boolean => ruleSelect.type === this.ruleType
      )
    ) {
      return;
    }

    this.clear();
  }
}
